var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},_vm._l((_vm.items),function(item,i){return _c('a',{key:i,staticClass:"item",on:{"click":function($event){return _vm.onSelect(item)}}},[(!_vm.hideColor)?_c('color-circle',{attrs:{"color":item.color,"color2":item.color2}}):_vm._e(),_vm._v(" "+_vm._s(item.text)+"\n  ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }